// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import apiHandle from '../../../../configs/apiConfig'


export const payrollManageCreate = createAsyncThunk('payrollManage/list-payroll/create', async (params) => {
  const response = await apiHandle('POST', 'list-payroll/create', params)
  return response
})

export const payrollManageUpdate = createAsyncThunk('payrollManage/list-payroll/update', async (params) => {
  const response = await apiHandle('PUT', 'list-payroll/update', params)
  return response
})

export const payrollManageRefund = createAsyncThunk('payrollManage/application/refund', async (params) => {
  const response = await apiHandle('POST', 'application/refund', params)
  return response
})

export const payrollManageDelete = createAsyncThunk('payrollManage/list-payroll/delete', async (params) => {
  const response = await apiHandle('DELETE', 'list-payroll/delete', params)
  return response
})


export const payrollManagePDFCreate = createAsyncThunk('payrollManage/application/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'application/pdf', params)
  return response
})

export const payrollManageReaderCard = createAsyncThunk('payrollManage/payrollManageReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})

export const payrollManageGetList = createAsyncThunk('payrollManage/list-payroll/list', async (params) => {
  const response = await apiHandle('GET', 'list-payroll/list', params)
  return response
})

export const getDataTable = createAsyncThunk('payrollManage/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'list-payroll/gettable', params)
  return response
})

export const payrollManageDataDetail = createAsyncThunk('payrollManage/payrollManageDataDetail', async (params) => {
  const response = await apiHandle('GET', 'list-payroll/get', params)
  return response
})

export const payrollManageGetCourse = createAsyncThunk('payrollManage/payrollManageGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getforpayrollManage', params)
  return response
})

export const getAllData = createAsyncThunk('payrollManage/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('payrollManage/getData', async params => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('payrollManage/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('payrollManage/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('payrollManage/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

const defaultpayrollManageDetail = {
  branch_id: null,
  createdAt: null,
  is_delete: null,
  list_payroll_id: null,
  updatedAtnull: null,
  name: null,
  value: null,
  title_value: null,
  condition: null,
  category: null,
  status: null,
  type: "income",
  createStatus: false
}


export const payrollManageSlice = createSlice({
  name: 'payrollManage',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      type: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      text: ''
    },
    payrollManageData: {
      data: [],
      filter: {
        branch: [],
        status: [],
        type: []
      },
      meta: {},
      isLoading: false
    },
    payrollManageDetail: {
      isEdit: false,
      dropdown: {
        branch: [],
        category_deduction: [],
        category_income: [],
        condition: [],
        status: [],
        title_value: [],
        type: []
      },
      payrollManageData: defaultpayrollManageDetail
    },
    alert: {
      active: false,
      message: ''
    },
    refundAndDelete: {
      application_id: null,
      note: null,
      value: null,
      err: false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'payrollManage/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    payrollManageNew: (state, action) => {
      if (action.type === 'payrollManage/payrollManageNew') {
        state.payrollManageDetail.isEdit = false
        state.payrollManageDetail.payrollManageData = defaultpayrollManageDetail
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    payrollManageAddHandle: (state, action) => {
      if (action.type === 'payrollManage/payrollManageAddHandle') {
        if (action.payload.target === 'course') {
          state.payrollManageDetail.payrollManageData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'other') {
          state.payrollManageDetail.payrollManageData.other_fee.push(defaultOtherCost)
        }

      }
    },
    payrollManageDeleteHandle: (state, action) => {
      if (action.type === 'payrollManage/payrollManageDeleteHandle') {
        if (action.payload.target === 'course') {
          state.payrollManageDetail.payrollManageData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'other') {
          state.payrollManageDetail.payrollManageData.other_fee.splice(action.payload.index, 1)
        }

      }

    },
    payrollManageDropdownHandle: (state, action) => {
      if (action.type === 'payrollManage/payrollManageDropdownHandle') {
        console.log(action.payload.target)
        if (action.payload.target === 'course' && state.payrollManageDetail.isEdit === false) {
          state.payrollManageDetail.payrollManageData.course[action.payload.index].course_id = action.payload.value.course_id
          state.payrollManageDetail.payrollManageData.course[action.payload.index].course_name = action.payload.value.name
          state.payrollManageDetail.payrollManageData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.payrollManageDetail.payrollManageData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'other' && state.payrollManageDetail.isEdit === false) {
          state.payrollManageDetail.payrollManageData.other_fee[action.payload.index].other_fee_id = action.payload.value.other_fee_id
          state.payrollManageDetail.payrollManageData.other_fee[action.payload.index].other_fee_name = action.payload.value.name
          state.payrollManageDetail.payrollManageData.other_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.payrollManageDetail.payrollManageData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    payrollManageOnChangeHandle: (state, action) => {
      if (action.type === 'payrollManage/payrollManageOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.payrollManageDetail.payrollManageData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.payrollManageDetail.payrollManageData[action.payload.target] = action.payload.value
        }

      }
    },
    payrollManageLoading: (state, action) => {
      if (action.type === 'payrollManage/payrollManageLoading') {
        state.payrollManageData.isLoading = true
      }
    },
    payrollManageAlert: (state, action) => {
      if (action.type === 'payrollManage/payrollManageAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    payrollManageRefundDelete: (state, action) => {
      if (action.type === 'payrollManage/payrollManageRefundDelete') {
        if (action.payload.target === null) {
          state.refundAndDelete.application_id = null
          state.refundAndDelete.note = null
          state.refundAndDelete.value = null
        } else {
          state.refundAndDelete[action.payload.target] = action.payload.value
        }

      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(payrollManageCreate.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/list-payroll/create/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
            // state.payrollManageDetail.payrollManageData.createStatus = true
            // state.payrollManageDetail.payrollManageData.pdf = action.payload.data
          }
        }
      })
      .addCase(payrollManageUpdate.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/list-payroll/update/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
            // state.payrollManageDetail.payrollManageData.createStatus = true
            // state.payrollManageDetail.payrollManageData.pdf = action.payload.data
          }
        }
      })
      .addCase(payrollManageRefund.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/application/refund/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(payrollManageDelete.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/list-payroll/delete/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = true
          } else {
            state.alert.active = true
            state.alert.message = action.payload.message
            state.alert.err = false
          }
        }
      })
      .addCase(payrollManageGetList.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/list-payroll/list/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            let branch = []
            let category_deduction = []
            let category_income = []
            let condition = []
            let status = []
            let title_value = []
            let type = []
            if (action.payload.data && Array.isArray(action.payload.data.branch)) {
              for (const i of action.payload.data.branch) {
                branch.push({ value: i.value, label: i.name })
              }
            }
            state.payrollManageDetail.dropdown.branch = branch

            if (action.payload.data && Array.isArray(action.payload.data.category_deduction)) {
              for (const i of action.payload.data.category_deduction) {
                category_deduction.push({ value: i, label: i })
              }
            }
            state.payrollManageDetail.dropdown.category_deduction = category_deduction

            if (action.payload.data && Array.isArray(action.payload.data.category_income)) {
              for (const i of action.payload.data.category_income) {
                category_income.push({ value: i, label: i })
              }
            }
            state.payrollManageDetail.dropdown.category_income = category_income

            if (action.payload.data && Array.isArray(action.payload.data.condition)) {
              for (const i of action.payload.data.condition) {
                let label = 'คูณ'
                if (i === 'fill') {
                  label = 'กำหนดเอง'
                }
                condition.push({ value: i, label: label })
              }
            }
            state.payrollManageDetail.dropdown.condition = condition

            if (action.payload.data && Array.isArray(action.payload.data.status)) {
              for (const i of action.payload.data.status) {
                status.push({ value: i, label: i })
              }
            }
            state.payrollManageDetail.dropdown.status = status

            if (action.payload.data && Array.isArray(action.payload.data.title_value)) {
              for (const i of action.payload.data.title_value) {
                title_value.push({ value: i, label: i })
              }
            }
            state.payrollManageDetail.dropdown.title_value = title_value

            if (action.payload.data && Array.isArray(action.payload.data.type)) {
              for (const i of action.payload.data.type) {
                type.push({ value: i, label: i })
              }
            }
            state.payrollManageDetail.dropdown.type = type
          }
        }
      })
      .addCase(getDataTable.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.payrollManageData = action.payload
            state.payrollManageData.isLoading = false
          }
        }
      })
      .addCase(payrollManageDataDetail.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/payrollManageDataDetail/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.payrollManageDetail.isEdit = true
            for (const i in action.payload.data) {
              let data = action.payload.data[i]
              if (data === null) data = ''
              state.payrollManageDetail.payrollManageData[i] = data
            }
          }
        }
      })
      .addCase(payrollManageGetCourse.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/payrollManageGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.payrollManageDetail.dropdown.course = action.payload.course
            state.payrollManageDetail.dropdown.other_fee = action.payload.other_fee
          }
        }
      })
      .addCase(payrollManageReaderCard.fulfilled, (state, action) => {
        if (action.type === 'payrollManage/payrollManageReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.payrollManageDetail.payrollManageData.prefix = action.payload.title_th
            state.payrollManageDetail.payrollManageData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.payrollManageDetail.payrollManageData.idcard = action.payload.nat_id
            state.payrollManageDetail.payrollManageData.birthday = action.payload.birthdate
            state.payrollManageDetail.payrollManageData.address = action.payload.address_no
            state.payrollManageDetail.payrollManageData.street = action.payload.address_road
            state.payrollManageDetail.payrollManageData.province = action.payload.address_provinice
            state.payrollManageDetail.payrollManageData.district = action.payload.address_amphor
            state.payrollManageDetail.payrollManageData.subdistrict = action.payload.address_tumbol
            state.payrollManageDetail.payrollManageData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(payrollManagePDFCreate.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'payrollManage/application/pdf/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

  }
})

export const { searchCriteria, payrollManageNew, payrollManageAddHandle, payrollManageDropdownHandle, payrollManageDeleteHandle, payrollManageOnChangeHandle, payrollManageLoading, payrollManageAlert, payrollManageRefundDelete } = payrollManageSlice.actions

export default payrollManageSlice.reducer
